import api from "./axiosInstance";
import networkConfig from "../utils/networkConfig";

const BASE = "/api/admin/items";

export const getSalesStats = async () => {
  const res = await api.get(networkConfig.salesAndInventory.getSalesStats);
  return res.data;
};

export const getAllShopItems = async (page = 1, limit = 10) => {
  const params = {};
  if (page) params.page = page;
  if (limit) params.limit = limit;
  const res = await api.get(networkConfig.salesAndInventory.getAllShopItems, {
    params,
  });
  return res.data;
};

export const getSnakeItems = async (filter) => {
  const params = {};
  if (filter) params.filter = filter;
  const res = await api.get(networkConfig.salesAndInventory.getSnake, {
    params,
  });
  return res.data;
};

export const getBackgroungItems = async (filter) => {
  const params = {};
  if (filter) params.filter = filter;
  const res = await api.get(networkConfig.salesAndInventory.getBackground, {
    params,
  });
  return res.data;
};

export const getPowerItems = async () => {
  const res = await api.get(networkConfig.salesAndInventory.getPowerUp);
  return res.data;
};

export const getItems = async (category) => {
  try {
    const res = await api.get(`${BASE}?category=${category}`);
    return res.data.items;
  } catch (err) {
    console.error("Error fetching items:", err);
    throw err;
  }
};

export const addItem = async (itemData) => {
  try {
    const res = await api.post(`${BASE}/add_item`, itemData);
    return res.data;
  } catch (err) {
    console.error("Error adding item:", err);
    throw err;
  }
};

export const updateItem = async (_id, itemData) => {
  try {
    const res = await api.put(`${BASE}/${_id}`, itemData);
    return res.data;
  } catch (err) {
    console.error("Error updating item:", err);
    throw err;
  }
};

export const toggleItemStatus = async (_id, status) => {
  try {
    const res = await api.patch(`${BASE}/${_id}`, { status });
    return res.data;
  } catch (err) {
    console.error("Error toggling status:", err);
    throw err;
  }
};

export const deleteItem = async (_id) => {
  try {
    const res = await api.delete(`${BASE}/${_id}`);
    return res.data;
  } catch (err) {
    console.error("Error deleting item:", err);
    throw err;
  }
};
